<template>
  <div class="modal_content_wrap">
    <div class="b_close" @click="$modal.hide('Product_modal')">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
        <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
      </svg>
    </div>
    <div class="product_wrap" v-if="!ProductsStore.modal.is_loading">
      <div class="item_cart" v-if="ProductsStore.modal.product.name">
        <div class="rows_wrap">
          <div class="row_w_label" v-if="ProductsStore.modal.product.category">
            <div class="label">Категория товара:</div>
            <div class="row">{{ProductsStore.modal.product.category}}</div>
          </div>
          <div class="row_w_label" v-if="ProductsStore.modal.product.brand">
            <div class="label">Бренд:</div>
            <div class="row">{{ProductsStore.modal.product.brand}}</div>
          </div>
          <div class="row_w_label" v-if="ProductsStore.modal.product.model">
            <div class="label">Модель:</div>
            <div class="row">{{ProductsStore.modal.product.model}}</div>
          </div>
          <div class="row_w_label">
            <div class="label">Наименование:</div>
            <div class="row">{{ProductsStore.modal.product.name}}</div>
          </div>
          <div class="row_w_label" v-if="ProductsStore.modal.product.cae">
            <div class="label">Артикул:</div>
            <div class="row">{{ProductsStore.modal.product.cae}}</div>
          </div>
          <div class="row_w_label" v-for="(property, pr_index) in ProductsStore.modal.product.properties" :key="pr_index">
            <div class="label">{{property.name}}</div>
            <div class="row">{{property.value}}</div>
          </div>
          <div class="row_w_label" v-if="ProductsStore.modal.product.tools">
            <div class="label">Описание:</div>
            <div class="row">{{ProductsStore.modal.product.tools.descr}}</div>
          </div>
          <div class="row_w_label" v-if="ProductsStore.modal.product.description">
            <div class="label">Описание:</div>
            <div class="row" v-html="ProductsStore.modal.product.description"></div>
          </div>
        </div>
        <div class="imgs_wrap">
          <div class="img img_model" v-if="ProductsStore.modal.product.main_image">
            <a class="image-popup" v-bind="{href:ProductsStore.modal.product.main_image}" target="_blank"><img v-bind="{src:ProductsStore.modal.product.main_image}" alt=""></a>
          </div>
<!--          <div class="img" v-else-if="ProductsStore.modal.product.media[0].original_url">-->
<!--            <a class="image-popup" v-bind="{href:ProductsStore.modal.product.media[0].original_url}"><img v-bind="{src:ProductsStore.modal.product.media[0].original_url}" alt=""></a>-->
<!--          </div>-->
          <div class="img" v-else>Нет изображения</div>
        </div>
      </div>
      <div class="item_cart" v-else>Ошибка - нет данных о товаре</div>
    </div>
    <div v-else class="loading">
      <loading></loading>
    </div>
  </div>
</template>

<script>
import { useProductsStore } from '@/stores/ProductsStore'
import loading from "@/components/support/loading";
export default {
  name: 'modalProduct',
  components: {
    loading,
  },
  setup() {
    const ProductsStore = useProductsStore()
    return {
      ProductsStore,
    }
  },
  data: function (){
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>

